import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, isRouteErrorResponse, RouterProvider, useRouteError } from 'react-router';
import { CssVarsProvider, CssBaseline } from '@mui/joy';
import RoundComponent from './components/Round';
import JoinRound from './components/JoinRound';
import CourseList from './components/CourseList';
import CourseDetails from './components/CourseDetails';
import CreateCourse from './components/CreateCourse';
import Layout from './components/Layout';
import MainContent from './components/MainContent';
import ErrorPage from './components/ErrorPage';
import Login from './components/Login';
import Signup from './components/Signup';
import ConfirmSignup from './components/ConfirmSignup';
import Account from './components/Account';
import { serviceFacade } from './services/service-facade';
import { configureAmplify } from './auth/amplify-config';
import { AuthProvider } from './auth/AuthContext';

configureAmplify();

const router = createBrowserRouter([
    {
        ErrorBoundary: RootErrorBoundary,
        Component: Layout,
        children: [
            { index: true, element: <MainContent /> },
            {
                path: '/:roundId/:playerId',
                Component: RoundComponent,
                loader: async ({ params }) => {
                    const response = await serviceFacade.getRound(params.roundId!, params.playerId!);
                    return {
                        round: response,
                    };
                },
            },
            {
                path: '/join/:roundId',
                Component: JoinRound,
                loader: async ({ params }) => {
                    const round = await serviceFacade.getSharedRound(params.roundId!);
                    return { round };
                },
            },
            {
                path: '/courses',
                Component: CourseList,
                loader: async () => {
                    const courses = await serviceFacade.listCourses();
                    return { courses };
                },
            },
            {
                path: '/courses/new',
                Component: CreateCourse,
            },
            {
                path: '/courses/:courseId',
                Component: CourseDetails,
                loader: async ({ params }) => {
                    const course = await serviceFacade.getCourse(params.courseId!);
                    return { course };
                },
            },
            {
                path: '/courses/:courseId/edit',
                Component: CreateCourse,
                loader: async ({ params }) => {
                    const course = await serviceFacade.getCourse(params.courseId!);
                    return { course };
                },
            },
            { path: '/login', Component: Login },
            { path: '/signup', Component: Signup },
            { path: '/confirm', Component: ConfirmSignup },
            { path: '/account', Component: Account },
        ],
    },
]);

function RootErrorBoundary() {
    let error = useRouteError();
    let message = 'An unexpected error occurred.';
    let status: number | undefined;

    if (isRouteErrorResponse(error)) {
        message = error.data || error.statusText;
        status = error.status;
    } else if (error instanceof Error) {
        message = error.message;
    }

    return (
        <Layout>
            <ErrorPage message={message} status={status} />
        </Layout>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <CssVarsProvider>
            <CssBaseline />
            <AuthProvider>
                <RouterProvider router={router} />
            </AuthProvider>
        </CssVarsProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
